<template>
    <div class="ces-question">
        <label v-bind:class="{ error: valid === false, valid: valid === true }"
            ><slot name="label"></slot
        ></label>
        <div class="text-recomend">
            <p>{{ t('question-ces_hard') }}</p>
            <p>{{ t('question-ces_easy') }}</p>
        </div>
        <div class="points clearfix">
            <div
                v-for="i in 7"
                :key="i"
                class="point"
                @click="setValue(i)"
                v-bind:class="{
                    active: currentValue == i,
                    inactive: currentValue !== null && currentValue !== i,
                }"
            >
                {{ i }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ces-question",
    props: {
        value: {
            type: Number,
            default: null,
        },
    },
    data: function () {
        return {
            currentValue: this.value,
            error: null,
            valid: null,
        };
    },
    methods: {
        setValue: function (value) {
            if (this.currentValue == value) {
                this.currentValue = null;
            } else {
                this.currentValue = value;
            }
            this.$emit("change", this.currentValue);
        },
        getValue: function () {
            return this.currentValue;
        },
        isValid: function () {
            this.valid = null;
            this.error = null;
            if (this.currentValue === null) {
                this.valid = false;
                this.error = this.t("question-select_option") + ".";
                return false;
            }
            this.valid = true;
            return true;
        },
        isNull: function () {
            if (this.currentValue === null) {
                return true;
            }
            return false;
        },
    },
    watch: {
        currentValue(newValue) {
            this.$emit("change", newValue);
        },
    },
};
</script>
